import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import { Layout, Menu, Space } from 'antd';
import { Responsive } from '../components';
import styled from '@xstyled/styled-components';
import { Content, Header } from 'antd/lib/layout/layout';
import { getColor, getSize } from '../hooks';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var appSiderWidth = 250;
var appSiderCollapsedWidth = 80;
var StyledLayout = styled(Layout)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100vh;\n  background: ", ";\n  padding: ", ";\n"])), getColor('fillIconBgDefault'), getSize('padding8'));
var StyledLayoutWithMenu = styled(Layout)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 100vh;\n  background: ", ";\n"])), getColor('fillIconBgDefault'));
var StyledHeader = styled(Header)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 ", " 0 ", ";\n"])), getColor('fillIconBgDefault'), getSize('padding8'), getSize('padding24'));
var StyledLogo = styled(Space)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  .ant-space-item {\n    display: flex;\n    align-items: center;\n  }\n"])));
var StyledLogoContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n"])));
var StyledSider = styled(Layout.Sider)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background: ", ";\n  transition: all 0.2s;\n  .ant-menu {\n    background: ", ";\n  }\n  .ant-menu-inline .ant-menu-item::after {\n    border-right: 0px;\n  }\n  .ant-menu-item-selected {\n    border-radius: ", ";\n  }\n  .ant-layout-sider-children {\n    padding-right: ", ";\n  }\n  .ant-menu-inline {\n    border-right: 0px !important;\n  }\n  &.ant-layout-sider-collapsed {\n    .ant-menu-inline-collapsed {\n      width: 100%;\n    }\n    .ant-menu-item,\n    .ant-menu-submenu-title,\n    .ant-menu-item-selected {\n      padding: ", " !important;\n      text-align: center;\n    }\n    .ant-menu-item .ant-menu-item-icon,\n    .ant-menu-item-selected .ant-menu-item-icon {\n      margin-inline-end: 0 !important;\n    }\n    .ant-menu-item-icon,\n    .anticon,\n    span[role='img'] {\n      margin: 0 !important;\n      margin-inline-end: 0 !important;\n      margin-inline-start: 0 !important;\n      font-size: 16px;\n    }\n    .ant-menu-title-content {\n      display: none !important;\n    }\n  }\n\n  .ant-layout-sider-trigger {\n    background: ", " !important;\n    color: black !important;\n    border-radius: ", ";\n    border: 1px solid ", ";\n\n    height: 40px !important;\n    line-height: 40px !important;\n    transition: all 0.2s;\n\n    width: 240px !important;\n    margin-bottom: ", ";\n\n    &:hover {\n      background: ", " !important;\n    }\n  }\n\n  &.ant-layout-sider-collapsed .ant-layout-sider-trigger {\n    width: 70px !important;\n  }\n"])), getColor('fillIconBgDefault'), getColor('fillIconBgDefault'), getSize('radius'), getSize('padding8'), getSize('padding4'), getColor('fillBgWhite'), getSize('radius'), getColor('fillIntSubActive'), getSize('padding16'), getColor('fillIntSubActive'));
var StyledContentLayout = styled(Content)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  background: ", ";\n  width: 100%;\n  overflow-y: auto;\n  border-radius: ", ";\n  &::-webkit-scrollbar {\n    width: 0px;\n  }\n"])), getColor('fillBgWhite'), getSize('radius'));
export var MainLayoutComponent = function MainLayoutComponent(_ref) {
  var children = _ref.children,
      header = _ref.header,
      menuItems = _ref.menuItems,
      hasMenu = _ref.hasMenu,
      hasHeader = _ref.hasHeader,
      selectedKey = _ref.selectedKey,
      defaultOpenKey = _ref.defaultOpenKey,
      bottomMenuItems = _ref.bottomMenuItems;
  var component = header.component,
      logo = header.logo;

  var _useState = useState(false),
      collapsed = _useState[0],
      setCollapsed = _useState[1];

  return /*#__PURE__*/_jsxs(StyledLayout, {
    children: [hasHeader && /*#__PURE__*/_jsxs(StyledHeader, {
      children: [/*#__PURE__*/_jsx(StyledLogo, {
        size: "middle",
        onClick: function onClick() {
          return window.location.href = '/';
        },
        children: /*#__PURE__*/_jsx(StyledLogoContainer, {
          children: logo
        })
      }), component]
    }), /*#__PURE__*/_jsxs(StyledLayoutWithMenu, {
      children: [hasMenu && /*#__PURE__*/_jsx(Responsive.DesktopScreen, {
        children: /*#__PURE__*/_jsxs(StyledSider, {
          width: appSiderWidth,
          collapsedWidth: appSiderCollapsedWidth,
          collapsible: true,
          collapsed: collapsed,
          onCollapse: function onCollapse(value) {
            return setCollapsed(value);
          },
          children: [/*#__PURE__*/_jsx(Menu, {
            defaultOpenKeys: defaultOpenKey,
            selectedKeys: [selectedKey],
            mode: "inline",
            items: menuItems,
            expandIcon: function expandIcon() {
              return null;
            },
            inlineCollapsed: collapsed
          }), /*#__PURE__*/_jsx("div", {
            style: {
              position: 'absolute',
              bottom: 24,
              width: '100%'
            },
            children: /*#__PURE__*/_jsx(Menu, {
              mode: "inline",
              selectedKeys: [],
              items: bottomMenuItems,
              style: {
                border: 'none',
                background: 'transparent'
              },
              inlineCollapsed: collapsed
            })
          })]
        })
      }), /*#__PURE__*/_jsx(StyledContentLayout, {
        $hasHeader: hasHeader,
        $hasMenu: hasMenu,
        children: children
      })]
    })]
  });
};